(function () {
    'use strict';

    /**
     *
     * @ngdoc service
     * @name manageUser.service:ManageUserServices
     *
     * @description
     *
     */
    angular
        .module('manageUser')
        .service('ManageUserServices', ManageUserServices);

    function ManageUserServices(ManageCrewFactory,CommonMasterData,RemoteService) {

        var self = this;

        var model={
            searchCriteria: ManageCrewFactory.getUserSearchRequest(),
        };

           var statusList = [
              {title:'Active', value: 'ACT'},
              {title:'Inactive', value: 'INA'},
              {title:'All', value: null}
           ];

        self.setSearchCriteria = function (data) {
            var searchCriteria = ManageCrewFactory.getUserSearchRequest();
            searchCriteria.startPosition = data.startPosition;
            searchCriteria.pageSize = data.pageSize;
            searchCriteria.loginId = data.loginId;
            searchCriteria.displayName = data.displayName;
            searchCriteria.userType = ( data.userType == null ? null : data.userType.userTypeCode );
            searchCriteria.status = ( data.status == null ? null : data.status.value );

            model.searchCriteria = searchCriteria;
        };

        self.searchUsers = function(successFn, errorFn){
            RemoteService.searchUsers(model.searchCriteria).then(
                function (response) {
                    if(response.success && !!response.users){
                    	var formatedResponse = ManageCrewFactory.formatUserSearchResponse(response.users);
                        successFn(formatedResponse,response.startPosition);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getNewUser = function(){
        	return ManageCrewFactory.getNewUser();
        }


        self.deleteUser = function (data, successFn, errorFn){
           var deleteUser = ManageCrewFactory.populateUserDeleteRequest(data);
           RemoteService.deleteUser(deleteUser).then(
               function (response) {
                   successFn(response);
               },
               function (error) {
                   errorFn(error.msg[0]);
               }
           );
        }

        self.saveUser = function (data,masterData, successFn, errorFn) {
            var saveUserRequest = ManageCrewFactory.populateSaveUserRequest(data,masterData);
            RemoteService.saveUser(saveUserRequest).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.searchUserTypes = function(successFn, errorFn) {
       	 	CommonMasterData.searchUserTypes(
       	 		 function (response) {
       	 			var formatedList = ManageCrewFactory.formatUserTypeResponse(response);
                    successFn(formatedList);
                 },
                 function (error) {
                     errorFn(error.msg[0]);
                 }
       	  );
        }

        self.searchCrewTypes = function(successFn, errorFn) {
        	 RemoteService.getCrewTypeList().then(
                   function (response) {
                	   var formatedList = ManageCrewFactory.formatCrewTypeResponse(response.crewTypeListDTOs);
                       successFn(formatedList);
                   },
                   function (error) {
                       errorFn(error.msg[0]);
                   }
             );
        }

        self.searchRoles = function(successFn, errorFn) {
            RemoteService.getAdminRoleNames().then(       
                function (response) {
                    successFn(response.adminRoleNamesResponse);  
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        }


        self.searchCrewNamesByCrewType = function(data,successFn, errorFn){
        	var userNamesRequest = ManageCrewFactory.getSearchUserByCrewTypeRequest(data);
        	RemoteService.loadCrewList(userNamesRequest).then(
                 function (response) {
                	 var formatedList = ManageCrewFactory.formatCrewSearchResponse(response.crewList);
                     successFn(formatedList);
                 },
                 function (error) {
                     errorFn(error.msg[0]);
                 }
           );
        }

        self.searchStatusOptions = function(){
        	return statusList;
        };

        self.userGridRowToUserDTO = function(selectedRow) {
        	var user = ManageCrewFactory.userGridRowToUserDTO(selectedRow);
			return user;
		}

        self.formatUserType = function(userTypeMasterData,rowData){
        	var row = rowData;
        	angular.forEach(userTypeMasterData, function (userType) {
	    		if(userType.userTypeCode == rowData.userType.userTypeCode){
	    			rowData.userType.userTypeDescription = userType.userTypeDescription;
	    			row = rowData;
	    		}
	        });

        	return row;
        }

      self.loadAirportList = function (successFn, errorFn) {
        RemoteService.loadAirportList().then(
          function (response) {
            var formatedList = ManageCrewFactory.formatAirportListResponse(response.airPortListDTOs);
            successFn(formatedList);
          },
          function (error) {
            errorFn(error.msg[0]);
          }
        );
      }

    }
})();
